<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="company">
        <el-input v-model="queryParams.company" :placeholder="$t('app.agent.list.companyName')" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="username">
        <el-input v-model="queryParams.username" :placeholder="$t('app.agent.list.nickname')" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="deptId" v-if="adminShow">
        <el-cascader
          :placeholder="$t('app.agent.list.department')"
          ref="myCascader"
          :options="deptOptions"
          :props="{ value : 'id' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.deptId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item  prop="salesmanUserId" v-if="adminShow">
        <el-select v-model="queryParams.salesmanUserId" filterable :placeholder="$t('app.agent.list.salesman')" @change="search" clearable>
          <el-option v-for="item in salemansData" :key="item.userId" :label="item.username + (!!item.realName?'-'+ item.realName:'')" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="phone">
        <el-input v-model="queryParams.phone" :placeholder="$t('app.agent.list.contactPhone')" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="levels" >
        <el-select v-model="queryParams.levels" multiple filterable :placeholder="$t('app.agent.list.level')" @change="search" clearable v-if="adminShow">
          <el-option v-for="item in levels" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="commissionModel" >
        <el-select v-model="queryParams.commissionModel" filterable :placeholder="$t('app.agent.list.commissionModel')" @change="search" clearable v-if="adminShow">
          <el-option v-for="item in gprsStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="autoWithdrawal" >
        <el-select v-model="queryParams.autoWithdrawal" :placeholder="$t('app.agent.list.autoWithdrawal')" @change="search" clearable v-if="adminShow">
          <el-option :label="$t('app.agent.list.no')" value="0"  >否</el-option>
          <el-option :label="$t('app.agent.list.yes')" value="1" >是</el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.agent.list.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.agent.list.reset') }}</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleCreate" v-hasPermi="['agent:add']">{{ $t('app.agent.list.add') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border @sort-change="tableSortChange" :empty-text="$t('app.common.noData')">
        <el-table-column type="expand" v-if="adminShow">
          <template slot-scope="props">
            <el-form label-position="left" class="table-expand">
              <el-row >
                  <el-col :span="8">
                    <el-form-item label="ID：" >
                      <span>{{ props.row.id }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="层级显示：" >
                      <span>{{ props.row.companyNameLevel }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="平台：" >
                      <span>{{ props.row.platformName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="创建时间：" >
                      <span>{{ props.row.createTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="部门：" >
                      <span>{{ props.row.deptName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="业务员：" >
                      <span>{{ props.row.saleName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="ids" :label="$t('app.agent.list.serialNumber')" align="center" width="60px"></el-table-column>
        <el-table-column prop="username" :label="$t('app.agent.list.nickname')" align="center"></el-table-column>
        <el-table-column prop="company" :label="$t('app.agent.list.companyName')" align="center"  min-width="200px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" :label="$t('app.agent.list.contactPerson')" align="center"></el-table-column>
        <el-table-column prop="commissionModel" :label="$t('app.agent.list.commissionModel')" align="center" v-if="adminShow" min-width="100">
          <template slot-scope="{row}" v-if="adminShow">
            <el-tag v-if="row.commissionModel == '1'">{{ $t('app.agent.list.floorPriceMode') }}</el-tag>
            <el-tag v-else-if="row.commissionModel == '0'" type="success">{{ $t('app.agent.list.proportionMode') }}</el-tag>
            <el-tag v-else type="warning">{{ $t('app.agent.list.flowPoolMode') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="level" :label="$t('app.agent.list.level')" align="center" v-if="adminShow" width="100px"></el-table-column>
        <el-table-column prop="phone" :label="$t('app.agent.list.contactPhone')" align="center" min-width="120"></el-table-column>
        <el-table-column prop="cardNumber" :label="$t('app.agent.list.deviceQuantity')" align="center" min-width="100" sortable="custom">
          <template slot-scope="scope">
            <el-link v-if="scope.row.cardNumber>0" type="primary" :underline="false" @click="jumpCard(scope.row.userId)">{{ scope.row.cardNumber }}</el-link>
            <span v-else>{{ scope.row.cardNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="monthSale" :label="$t('app.agent.list.monthlyRechargeAmount')" align="center" min-width="120" sortable="custom"></el-table-column>
        <el-table-column :label="$t('app.agent.list.status')" align="center" prop="status" v-if="adminShow">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == '0'" type="danger">{{ $t('app.agent.list.deleted') }}</el-tag>
              <el-switch v-else
                v-model="scope.row.status"
                active-value="1"
                inactive-value="2"
                @change="handleStatusChange(scope.row)"
              ></el-switch>
            </template>
        </el-table-column>
        <el-table-column :label="$t('app.agent.list.operation')" align="center" min-width="260" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-s-data"
                @click="dashboard(scope.row)"
                v-hasPermi="['agent:dashboard']"
              >{{ $t('app.agent.list.operationStatus') }}</el-button>
              <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-edit"
                @click="editRow(scope.row)"
                v-hasPermi="['agent:edit']"
              >{{ $t('app.agent.list.edit') }}</el-button>
              <el-dropdown @command="(command) => handleCommand(command, scope.row)" v-hasPermi="['agent:switchUser', 'agent:sendMessage','agent:noticeSetting','agent:dataProcess','agent:restPassword','agent:customProduct']">
                <span class="el-dropdown-link">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>{{ $t('app.agent.list.more') }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="switchUser" icon='el-icon-guide'
                    v-hasPermi="['agent:switchUser']">{{ $t('app.agent.list.accountSwitch') }}</el-dropdown-item>
                  <el-dropdown-item command="sendMessage" icon="el-icon-message"
                    v-hasPermi="['agent:sendMessage']">{{ $t('app.agent.list.smsPush') }}</el-dropdown-item>
                    <el-dropdown-item command="noticeSetting" icon="el-icon-message-solid"
                    v-hasPermi="['agent:noticeSetting']">{{ $t('app.agent.list.reminderSetting') }}</el-dropdown-item>
                    <el-dropdown-item command="dataProcess" icon="el-icon-s-grid"
                    v-hasPermi="['agent:dataProcess']">{{ $t('app.agent.list.dataAnalysis') }}</el-dropdown-item>
                    <el-dropdown-item command="handleResetPwd" icon="el-icon-key"
                    v-hasPermi="['agent:restPassword']">{{ $t('app.agent.list.resetPassword') }}</el-dropdown-item>
                    <el-dropdown-item command="handleCustomProduct" icon="el-icon-setting"
                    v-hasPermi="['agent:customProduct']">{{ $t('app.agent.list.packageSetting') }}</el-dropdown-item>
                    <el-dropdown-item command="handleApiDoc" icon="el-icon-folder"
                    v-hasPermi="['agent:apiDoc']">{{ $t('app.agent.list.apiInfo') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 代理商提醒设置 -->
    <el-dialog :title="noticeTitle" :visible.sync="openNotice" @close="cancelNotice" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="noticeForm" :model="noticeForm" :rules="noticeRules" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="提醒方式" prop="type">
              <el-checkbox-group v-model="noticeForm.type">
                <el-checkbox
                  v-for="dict in noticeTypes"
                  :key="dict.value"
                  :label="dict.value"
                >{{dict.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="提醒内容" prop="classification">
              <el-checkbox-group v-model="noticeForm.classification">
                <el-checkbox 
                  v-for="dict in noticeMessage"
                  :key="dict.value"
                  :label="dict.value"
                  @change="noticeMessageChange($event,dict.value)"
                >{{dict.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="18" v-if="stopShow">
            <el-form-item prop="stopTime">
              <span slot="label">
                <el-tooltip content="最近指定天数内的停机的流量卡，单位天" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                停机时长
              </span>
              <el-input v-model="noticeForm.stopTime" placeholder="最近几天内的停机" />
            </el-form-item>
          </el-col>
          <el-col :span="18" v-if="monthFlowShow">
            <el-form-item  prop="monthFlow">
              <span slot="label">
                <el-tooltip content="当月流量剩余指定大小时推送信息，单位MB" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                流量阀值
              </span>
              <el-input v-model="noticeForm.monthFlow" placeholder="当月流量剩余多少" />
            </el-form-item>
          </el-col>
          <el-col :span="18" v-if="expireShow">
            <el-form-item prop="expireTime">
              <span slot="label">
                <el-tooltip content="最近天数内的套餐将要过期的流量卡，单位天" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                套餐到期时间
              </span>
              <el-input v-model="noticeForm.expireTime" placeholder="最近指定天数内的套餐将要过期的流量卡" />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item   prop="timeCycle">
              <span slot="label">
                <el-tooltip content="设置每月的某些天提醒，例如1,2,3 表示每月的1号，2号，3号推送消息" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                时间周期
              </span>
              <el-input v-model="noticeForm.timeCycle" placeholder="提醒内容的时间间隔，多个时间使用,隔开" />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="是否启用"  prop="status">
              <el-radio-group v-model="noticeForm.status">
                <el-radio  label="1">启用</el-radio>
                <el-radio  label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitNoticeForm" >确 定</el-button>
        <el-button @click="cancelNotice">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 代理商短信发送 -->
    <el-dialog :title="messageTitle" :visible.sync="openMessage" @close="cancelMessage" width="800px" append-to-body :close-on-click-modal="false">
      <el-form ref="messageForm" :model="messageForm" :rules="messageRules" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item  label="代理商名称">
              <el-input placeholder="代理商名称" v-model="messageForm.agentName" type="text" disabled style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="代理商卡信息">
              <el-row>
                <el-col :span="24">
                  <el-checkbox-group v-model="messageForm.checkMessages" @change="handleCheckedMessageChange" :disabled="checkMessage">
                    <el-row :gutter="16">
                      <el-col :span="8"><el-checkbox :label="'总卡数'+countAgentCardData.total+'张'"></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox :label="'停机数'+countAgentCardData.shutDown+'张'"></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox :label="'激活数'+countAgentCardData.activated+'张'"></el-checkbox></el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="8"><el-checkbox :label="'联通卡数'+countAgentCardData.unicom+'张'"></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox :label="'移动卡数'+countAgentCardData.mobile+'张'"></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox :label="'电信卡数'+countAgentCardData.telecom+'张'"></el-checkbox></el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="8"><el-checkbox :label="'联通停机数'+countAgentCardData.unicomStop+'张'"></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox :label="'移动停机数'+countAgentCardData.mobileStop+'张'"></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox :label="'电信停机数'+countAgentCardData.telecomStop+'张'"></el-checkbox></el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="8"><el-checkbox :label='"套餐即将到期"+countAgentCardData.expire+"张"'></el-checkbox></el-col>
                      <el-col :span="8"><el-checkbox label="开通的物联网卡已经停机"></el-checkbox></el-col>
                    </el-row>
                  </el-checkbox-group>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item  prop="phone">
              <span slot="label">
                <el-tooltip content="创建代理商时填入的手机号，如果没有，需要手动输入" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                手机号码
              </span>
              <el-input placeholder="输入手机号" v-model="messageForm.phone" type="text" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="短信模板" prop="templateId">
            <el-select v-model="messageForm.templateId"  placeholder="请选择模板" filterable @change="templateInfo($event)"  style="width: 100%;">
            <el-option
                  v-for="dict in templates"
                  :key="dict.id"
                  :label="dict.name"
                  :value="dict.id"
                ></el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="24" v-show="!!messageForm.templateId">
            <el-form-item label="模板">
              <el-input   v-model="messageForm.template" type="textarea" style="width: 100%;" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-show="!!messageForm.templateId">
            <el-form-item prop="content">
              <span slot="label">
                <el-tooltip content="将内容的占位符用文字替换掉就可以直接发送信息" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                模板格式
              </span>
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="messageForm.content"></el-input>
              <span><em>举例：{{messageForm.remark}}</em></span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitMessageForm" >确 定</el-button>
        <el-button @click="cancelMessage">取 消</el-button>
      </div>
    </el-dialog>
    <!-- api接口对接 -->
    <el-dialog :title="$t('app.agent.list.apiDocTitle')" :visible.sync="openApi"  width="800px" append-to-body :close-on-click-modal="false">
      <el-descriptions  direction="vertical" :column="4" border>
        <el-descriptions-item label="APPID/UserId">{{apiData.userId}}</el-descriptions-item>
        <el-descriptions-item :label="$t('app.agent.list.secretKey')">{{apiData.security}}</el-descriptions-item>
        <el-descriptions-item :label="$t('app.agent.list.apiDeductionMode')">
          <el-tag type="danger">{{apiData.apiDeduction}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('app.agent.list.documentDownload')">
          <el-link type="primary" @click="apiDown">{{ $t('app.agent.list.juziApiDoc') }}</el-link>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeApi">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { agentListsData ,saveOrUpdateUserNotice,userNoticeDetail,smsTemplateList,smsTemplateDetail,sendUserMesaage,apiAgent} from "@/api/api.js";
import { agentCardStatistic } from "@/api/api.js"; //代理商卡统计信息
import { restPassword ,deptTreeSelect ,usersSalemansList,changeUserStatus} from "@/api/api"; //重置密码
export default {
  name: "agent",
  data() {
    return {
      queryParams: {
        company:undefined,
        username:undefined,
        phone:undefined,
        levels:[],
        commissionModel:undefined,
        autoWithdrawal:undefined
      },
      deptOptions:[],
      salemansData:[],
      tableData: [],
      userId: "",
      page: 1,
      pageSize: 20,
      total: 0,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      gprsStatus:[
        {
          value: 0,
          label: "比例模式"
        },
        {
          value: 1,
          label: "底价模式"
        },
        {
          value: 2,
          label: "流量池模式"
        },
      ],
      levels:[
        {
          value: "1",
          label: "1级"
        },
        {
          value: "2",
          label: "2级"
        },
        {
          value: "3",
          label: "3级"
        },
        {
          value: "4",
          label: "4级"
        },
        {
          value: "5",
          label: "5级"
        },
        {
          value: "6",
          label: "6级"
        }
      ],
      noticeTypes:[
        {
          value: "1",
          name: "平台提醒"
        },
        {
          value: "2",
          name: "短信提醒"
        },
        {
          value: "3",
          name: "公众号提醒"
        }
      ],
      noticeMessage:[
        {
          value: "1",
          name: "停机提醒"
        },
        {
          value: "2",
          name: "流量用完"
        },
        {
          value: "3",
          name: "套餐到期"
        }
      ],
      stopShow:false,
      monthFlowShow:false,
      expireShow:false,
      noticeTitle:"代理商消息提醒设置",
      openNotice:false,
      noticeForm:{
        userId:undefined,
        type:[],
        classification:[],
        expireTime:undefined,
        stopTime:undefined,
        monthFlow:undefined,
        timeCycle:undefined,
        status:'1'
      },
      noticeRules:{
        type: [
          { required: true, message: "提醒方式不能为空", trigger: "blur" }
        ],
        classification: [
          { required: true, message: "提醒内容不能为空", trigger: "blur" }
        ],
        stopTime: [
          { required: true, message: "停机时长不能为空", trigger: "blur" }
        ],
        expireTime: [
          { required: true, message: "套餐到期时间不能为空", trigger: "blur" }
        ],
        monthFlow: [
          { required: true, message: "流量阀值不能为空", trigger: "blur" }
        ],
        timeCycle: [
          { required: true, message: "时间周期不能为空", trigger: "blur" }
        ],
      },
      messageTitle:'代理商短信发送',
      openMessage:false,
      checkMessage:true,
      messageForm:{
        userId:undefined,
        templateId:undefined,
        agentName:undefined,
        company:undefined,
        phone:undefined,
        template:undefined,
        content:'',
        remark:'',
        checkMessages:[]
      },
      countAgentCardData:{
        mobile:0,
        unicom:0,
        telecom:0,
        mobileStop:0,
        unicomStop:0,
        telecomStop:0,
        total:0,
        activated:0,
        shutDown:0,
        delAccount:0,
        expire:0
      },
      templateMsg:'',
      messageRules:{
        templateId: [
          { required: true, message: "短信模板不能为空", trigger: "blur" }
        ],
        phone:[
          { required: true, message: "手机号不能为空", trigger: "blur" }
        ],
        content:[
          { required: true, message: "短信内容不能为空", trigger: "blur" }
        ]
      },
      templates:[],
      activeNames: ['1'],
      openApi:false,
      apiData:'',
    };
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType =='1'
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'agent'){
          this.initData();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    /** 查询部门下拉树结构 */
    getDeptTree() {
        deptTreeSelect().then(res => {
          this.deptOptions = res.data.data;
        });
    },
    getUsersSalemans(){
       usersSalemansList({}).then(res=>{
         this.salemansData = res.data.data;
       }) 
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop === 'id'){
        this.sortName = 'id'
      }else if(val.prop === 'cardNumber'){
        this.sortName = 'card_number'
      }else if(val.prop === 'monthSale'){
        this.sortName = 'month_sale'
      }
      this.initData()
    },
    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "switchUser":
          this.switchUser(row);
          break;
        case "sendMessage":
          this.sendMessage(row);
          break;
        case "noticeSetting":
          this.noticeSetting(row);
          break;
        case "dataProcess":
          this.dataProcess(row);
          break;
        case "handleResetPwd":
          this.handleResetPwd(row);
          break;
        case "handleCustomProduct":
          this.handleCustomProduct(row);
          break;
        case "handleApiDoc":
          this.handleApiDoc(row);
          break;
        default:
          break;
      }
    },
    // 新增代理商
    handleCreate(){
      this.$router.push('/partners/createAgent');
    },
    // 获取列表信息
    initData() {
      let params = {
        model: {
        ...this.queryParams,
        order: this.sortOrder,
        sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      agentListsData(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
          })
        }
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 运营情况
    dashboard(row) {
      if(row.commissionModel === "2"){
        this.$router.push({ path: "/dashboardpool", query: {userId: row.userId,username:row.username} });
      } else {
        this.$router.push({ path: "/agent/dashboard", query: {userId: row.userId,username:row.username} });
      }
    },
    // 修改数据
    editRow(row) {
      this.$router.push({ path: "/agent/edit", query: {userId: row.userId} });
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.status === "1" ? "启用" : "锁定";
      this.$modal.confirm('确认要"' + text + '""' + row.username + '"用户吗？').then(function() {
        let params = {
          userId:row.userId,
          status:row.status
        }
        return changeUserStatus(params);
      }).then(() => {
        this.$modal.msgSuccess(text + "成功");
      }).catch(function() {
        row.status = row.status === "1" ? "2" : "1";
      });
    },
    //切换代理商账号
    switchUser(row){
      this.$prompt('请输入原账号密码', '提示', {
          inputType: 'password',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^.+$/,
          inputErrorMessage: '密码不能为空'
        }).then(({ value }) => {
          let params = {
            userId:row.userId,
            password:value
          }
          this.$store.dispatch("SwitchLogin", params).then(() => {
            //重新加载页面
            window.location.href = window.location.origin;
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消切换'
          });       
        });
      
    },
    noticeMessageChange(event,classification){
      if(classification ==1){
        this.stopShow = event;
      }
      if(classification ==2){
        this.monthFlowShow = event;
      }
      if(classification ==3){
        this.expireShow = event;
      }
      
    },
    userNoticeDetail(userId){
        userNoticeDetail({userId:userId}).then(res=>{
          let data = res.data.data;
          if(!!data){
              this.noticeForm = data;
              this.stopShow = !!data.stopTime;
              this.monthFlowShow = !!data.monthFlow;
              this.expireShow = !!data.expireTime;
          }
        });
    },
    sendMessage(row){
      this.messageForm.userId = row.userId;
      this.messageForm.agentName = '['+ row.username + ']' + row.company
      this.messageForm.company = row.company
      this.messageForm.phone = row.phone
      this.messageTemplateMethod();
      this.agentCardStatisticMethod();
      this.openMessage = true;
    },
    noticeSetting(row){
        this.noticeForm.userId = row.userId;
        this.openNotice =true;
        this.userNoticeDetail(row.userId);
    },
    dataProcess(row){
        this.$router.push('/agent/dataProcess/'+row.userId);
    },
    submitNoticeForm(){
      this.$refs["noticeForm"].validate(valid => {
        if (valid) {
          saveOrUpdateUserNotice(this.noticeForm).then(res => {
              if(res.data.code ==200){
                this.$message.success("编辑成功");
                this.cancelNotice();
                this.initData();
              }else{
                this.$message.error(res.data.message);
              }
            });
        }
      });
    },
    //套餐设置
    handleCustomProduct(row){
      // this.$router.push({path:"/agent/customProduct",query:{userId: row.userId}});
      this.$router.push({name: 'AgentProduct',params:{userId: row.userId}});
    },
    //api接口对接
    handleApiDoc(row){
      this.openApi = true;
      apiAgent({userId:row.userId}).then(res=>{
          this.apiData = res.data.data;
      })
    },
    //api文档下载
    apiDown(){
      this.download('/api/apiDown', {
      }, `桔子智联对接文档.docx`)
    },
    closeApi(){
      this.openApi = false;
    },
    cancelNotice(){
      this.openNotice =false;
      this.stopShow = false;
      this.monthFlowShow = false;
      this.noticeForm ={
        userId:undefined,
        type:[],
        classification:[],
        stopTime:undefined,
        monthFlow:undefined,
        timeCycle:undefined
      }
      this.resetForm("noticeForm");
    },
    cancelMessage(){
      this.messageForm.checkMessages = [];
      this.checkMessage = true;
      this.openMessage = false;
      this.resetForm("messageForm");
    },
    messageTemplateMethod(){
      let param = {
        type:"1"
      }
      smsTemplateList(param).then(res=>{
          if(res.data.code == 200){
              this.templates = res.data.data;
          }
      });
    },
    templateInfo(id){
      this.checkMessage = true;
      this.messageForm.checkMessages = [];
      smsTemplateDetail({id:id}).then(res=>{
        if(res.data.code == 200){
            let reg = /name/gi;
            this.messageForm.content = res.data.data.content.replace(reg,this.messageForm.company);
            this.messageForm.template = res.data.data.content;
            this.templateMsg = res.data.data.content.replace(reg,this.messageForm.company);
            this.messageForm.remark = res.data.data.remark
            if(res.data.data.code.indexOf('SMS_CUSTOMER')>=0){
                this.checkMessage = false;
            }
        }
      })
    },
    submitMessageForm(){
        this.$refs["messageForm"].validate(valid => {
        if (valid) {
          sendUserMesaage(this.messageForm).then(res => {
              if(res.data.code ==200){
                this.$message.success("短信发送成功");
                this.cancelMessage();
              }else{
                this.$message.error(res.data.message);
              }
            });
        }
      });
    },
    jumpCard(userId){
      this.$router.push({name:'cards',params:{userId:userId}});
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$modal.confirm('是否确认重置公司为"' + row.company + '"的密码？').then(() =>  {
         restPassword({userId : row.userId}).then(res => {
            this.$modal.msgSuccess("重置密码成功");
            this.initData();
          });
      }).catch(() => {});
    },
    handleCheckedMessageChange(){
      if(this.messageForm.checkMessages.length>0){
          let msgRex = /msg/gi;
          let msgcRex = /msg，text/gi;
          let msg = this.messageForm.checkMessages.join("，");
          if(this.templateMsg.indexOf('msg，text')>=0){
              this.messageForm.content = this.templateMsg.replace(msgcRex,msg);
          }else{
              this.messageForm.content = this.templateMsg.replace(msgRex,msg);
          }
      }else{
        this.messageForm.content = this.templateMsg;
      }
    },
    agentCardStatisticMethod(){
      let params = {
        userId:this.messageForm.userId
      }
      agentCardStatistic(params).then(res=>{
        if(res.data.code == 200){
            this.countAgentCardData = res.data.data;
        }
      });

    }
  },
  created() {
    this.initData();
    if(this.adminShow){
      this.getDeptTree();
      this.getUsersSalemans();
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 20px;
  label{
    width: 90px;
    color: #99a9bf; 
  }
  .el-form-item{
    margin-bottom: 0;
  }
}

</style>


